import { CSSResultGroup, html, TemplateResult } from 'lit';
import { customElement, property } from 'lit/decorators.js';

import componentStyles from './ghs-phone-contact.css.lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import '../ghs-icon/ghs-icon';
import formatTelURI from '../../../utilities/format-tel-uri';

export type phoneContactNumber = number;

import {
  screenSizeMap,
  ScreenSizeController,
} from '../../controllers/screen-size-controller';

/**
 * The Phone Contact component
 *
 * @element ghs-phone-contact
 */
@customElement('ghs-phone-contact')
export class GhsPhoneContact extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  // eslint-disable-next-line
  // @ts-ignore
  private _screenSizeController = new ScreenSizeController(this);

  /**
   * Phone number.
   * @param phone
   * @default String
   */
  @property({ attribute: 'phone', reflect: true })
  phone: String;

  /**
   * Custom text for mobile.
   * @param mobileText
   * @default String
   */
  @property({ attribute: 'mobile-text', reflect: true })
  mobileText: String = '';

  render(): TemplateResult {
    const isMobile: boolean =
      window.innerWidth < (screenSizeMap.get('sm') as number);
    const isLarge: boolean =
      window.innerWidth >= (screenSizeMap.get('lg') as number);
    const isInHeader: boolean =
      !isLarge && this.closestElement('ghs-header') !== null;
    const phone = formatTelURI(this.phone);

    return html`
      <a class="phone-contact ${isInHeader ? 'header' : ''}" href="${phone}">
        <ghs-icon
          name="phone"
          size="18px"
          mobile-size="18px"
          site=${this.site}
        ></ghs-icon>

        <span class="label">
          ${isMobile && this.mobileText != ''
            ? `
            ${this.mobileText}
          `
            : html`<slot></slot>`}
        </span>
      </a>
    `;
  }
}
